import {
  AutoComplete,
  DatePicker,
  Form,
  Input,
  Modal,
  Radio,
  message,
  Tooltip,
} from "antd";
import moment from "moment";
import React, { useContext, useEffect } from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { createTimeSlots } from "../../../Helpers/DateHelpers";
import { createDropdownValues } from "../../../Helpers/helperFunctions";
import UploadReportComponent from "../../Common/UploadReportComponent/UploadReportComponent";
import CustomPhoneInputV2 from "../../CustomPhoneInputV2/CustomPhoneInputV2";
import Dropdown from "../../DropDown/Dropdown";
import AddMemberModal from "../AddMemberModal/AddMemberModal";
import styles from "./index.module.scss";
import ConsultationModePicker from "../CustomPickers/ConsultationModePicker";
import { InterbranchContext } from "../../../pages/InterbranchAdmin/InterbranchAdminHome";
import GenderPicker from "../CustomPickers/GenderPicker";
import {
  bookingformRequest,
  fetchPatientDetail,
  fetchPatientLovedOne,
  fetchclinicnames,
  fetchconsultation,
  fetchdoctor,
  fetchspecilaity,
  fetchtimezone,
  CheckuserEmailavailbility,
} from "../../../actions/Quickbooking";

import debounce from "lodash.debounce";
import { fetch_doctors_list } from "../../../actions/ClinicAdminAction";
import { Select } from "antd";
import Spinner from "react-bootstrap/Spinner";
import { fetch_clientDetails } from "../../../actions/MicrositeAction";
import { fetchgangaSpeciality,fetchallSpeciality } from "../../../actions/SpecialityListingAction";
import { ConsoleSqlOutlined } from "@ant-design/icons";

const { TextArea } = Input;
//"antd": "^4.16.13",
function BoookRequest() {
  let dispatch = useDispatch();

  let [activeTab, setActiveTab] = useState(0);
  let [addNewForm, SetAddNewForm] = useState(false);
  const [addMemberFormData, setAddMemberFormData] = useState({});
  let [bookingSuccessModal, setBookingSuccessModal] = useState(false);
  let [sendSuccessModal, setSendSuccessModal] = useState(false);
  let [FormsubmissionType, setFormSubmissionType] = useState(false);
  let [members, setMembers] = useState([
    { name: "", dob: "", gender: "", relationship: "" },
    { name: "", dob: "", gender: "", relationship: "" },
  ]);

  let { bookingForm } = useSelector((state) => state?.interbranchAdmin);
  const { interbranchData, setInterbranchdata } =
    useContext(InterbranchContext);
  let { isTouched, progress } = bookingForm;
  const [form] = Form.useForm();
  const { Option } = Select;
  console.log("interbranchData", interbranchData);
  useEffect(() => {
    setActiveTab(progress);
  }, [progress]);
  const [isAppointmentAlreadyBooked, setIsAppointmentAlreadyBooked] = useState(false);
  const [mobileNumberError, setMobileNumberError] = useState(false);
  let tabs = [
    { name: "Patient details", id: 0 },
    { name: "Doctor Details", id: 1 },
    { name: "Appointment Details", id: 2 },
    { name: "Payment Details", id: 3 },
  ];

  //Migrates from tab
  let dummyDoctors = ["Doctor1", "Doctor2", "Doctor3"];
  let dummyCurrency = [
    "AED",
    "AFN",
    "ALL",
    "AMD",
    "ANG",
    "AOA",
    "ARS",
    "AUD",
    "AWG",
    "AZN",
    "BAM",
    "BBD",
    "BDT",
    "BGN",
    "BIF",
    "BMD",
    "BND",
    "BOB",
    "BRL",
    "BSD",
    "BWP",
    "BYR",
    "BZD",
    "CAD",
    "CDF",
    "CHF",
    "CLP",
    "CNY",
    "COP",
    "CRC",
    "CUP",
    "CVE",
    "CZK",
    "DJF",
    "DKK",
    "DOP",
    "DZD",
    "EEK",
    "EGP",
    "ERN",
    "ETB",
    "EUR",
    "FJD",
    "FKP",
    "GBP",
    "GEL",
    "GHS",
    "GIP",
    "GMD",
    "GNF",
    "GTQ",
    "GYD",
    "HKD",
    "HNL",
    "HRK",
    "HTG",
    "HUF",
    "IDR",
    "ILS",
    "INR",
    "ISK",
    "JMD",
    "KES",
    "KGS",
    "KHR",
    "KMF",
    "KRW",
    "KYD",
    "KZT",
    "LAK",
    "LBP",
    "LKR",
    "LRD",
    "LSL",
    "LTL",
    "LVL",
    "LYD",
    "MAD",
    "MDL",
    "MGA",
    "MKD",
    "MMK",
    "MNT",
    "MOP",
    "MRO",
    "MUR",
    "MVR",
    "MWK",
    "MXN",
    "MYR",
    "MZN",
    "NAD",
    "NGN",
    "NIO",
    "NOK",
    "NPR",
    "NZD",
    "PAB",
    "PEN",
    "PGK",
    "PHP",
    "PKR",
    "PLN",
    "PYG",
    "QAR",
    "RON",
    "RSD",
    "RUB",
    "RWF",
    "SAR",
    "SBD",
    "SCR",
    "SEK",
    "SGD",
    "SHP",
    "SLL",
    "SOS",
    "SRD",
    "STD",
    "SYP",
    "SZL",
    "THB",
    "TJS",
    "TMT",
    "TND",
    "TOP",
    "TRY",
    "TTD",
    "TWD",
    "TZS",
    "UAH",
    "UGX",
    "USD",
    "UYU",
    "UZS",
    "VEF",
    "VND",
    "VUV",
    "WST",
    "XAF",
    "XCD",
    "XOF",
    "XPF",
    "YER",
    "ZAR",
    "ZMK",
  ];
  let dummySpecialities = ["Speciality1", "Speciality2", "Speciality3"];
  let dummyClinics = ["Clinic-1", "Clinic-2", "Clinic-3"];
  let tempValues = {
    reasons: ["Reason 1", "Reason 2", "Reason 3"],
    paymentMethod: ["Google Pay", "Razorpay", "To Account", "Other"],
  };
  let tempData = {
    modeOfConsultation: ["Video"],
    typeOfConsultation: ["First time consultation", "First time consultation"],
    appointmentTime: ["Time 1", "Time 2", "Time 3"],
  };

  let tempReasons = [
    "Doctor not available at scheduled time",
    "Patient not available at scheduled time",
    "Payment received from link",
    "Free appointment",
    "Included in a package",
    "Technical issue",
    "Doctor redirection",
    "Direct payment",
    "Others",
  ];
  const [isTimeZoneEnabled, setIsTimeZoneEnabled] = useState(false);
  let [formData, setForm] = useState({ ...interbranchData.bookingForm });
  let [isPhoneError, setPhoneError] = useState(false);
  let [timeSlots, setTimeSlots] = useState();
  const [clinicNames, setClinicNames] = useState([]);
  const [specialities, setSpecialities] = useState([]);
  const [doctorNames, setDoctorNames] = useState([]);
  const [consultationNames, setConsultationNames] = useState([]);
  const [doctorTimezoneData, setDoctorTimezoneData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [selectedCurrency, setSelectedCurrency] = useState(null);
  const [selectedDoctorValue, setSelectedDoctorValue] = useState(null);
  const [selectedDepartment, setSelectedDepartment] = useState(null);
  const [familyMembers, setFamilyMembers] = useState([]);
  const [familyMembersdetails, setfamilyMembersDetails] = useState({});
  const [selfMembersDetails, setselfMembersDetails] = useState([]);
  const [successmessage, setSuccessMessage] = useState("");
  const [errormessage, setErrormessage] = useState("");
  let [patienType, setPatientType] = useState("newPatient");
  const [isSumbit, setIsSumbit] = useState(true);
  const [showself, setShowself] = useState(false);
  const [blockBooking, setblockBooking] = useState(false);
  const [loader, setLoader] = useState(false);
  const [emailerrormsg, setEmailerrormsg] = useState("");

  const [departmentOptions, setDepartmentOptions] = useState([]);
  const [specialityOptions, setSpecialityOptions] = useState([]);
  const [clinicId, setClinicId] = useState(null);

  useEffect(() => {
    
    dispatch(fetchallSpeciality()).then((res) => {
      if (res) {
        console.log("department", res);
        const options = res.map((item) => ({
          id: item.SpecialityId,
          name: item.specialityName,
        }));
        setSpecialityOptions(options);
      }
    });
    
  }, []);
  console.log('departmentsss', departmentOptions)
console.log('selected', selectedDepartment)

  const fetchFamilyMembers = async (email) => {
    try {
      const members = await dispatch(fetchPatientLovedOne(email));
      setFamilyMembers(members);
      setShowself(true);
    } catch (err) {
      console.error("Error fetching family members", err);
    }
  };

  const fetchDepartments = async (sepciality) => {
    dispatch(fetchgangaSpeciality(sepciality)).then((res) => {
      if (res) {
        console.log("department", res);
        const options = res.map((item) => ({
          id: item.specialityId,
          name: item.subspecialityName,
        }));
        setDepartmentOptions(options);
      }
    });
  };

  useEffect(() => {
    dispatch(fetchclinicnames()).then((res) => {
      const names = res.clinicDetail.map((clinic) => ({
        text: clinic.clinicName,
        value: clinic.doctorId,
        clinicId: clinic.clinicId,
      }));
      setClinicNames(names);
    });

    dispatch(fetch_doctors_list("Ganga Hospital")).then((res) => {
      if (res) {
        setDoctorNames(res);
      }
    });
  }, []);

  useEffect(() => {
    form.setFieldsValue({
      email: formData.patientemail,
    });
  }, [formData.patientemail]);

  const handleClinicChange = async (selectedDoctorId, clinicId) => {
    console.log("Selected Doctor ID:", selectedDoctorId);
    console.log("Selected Clinic ID:", clinicId);

    try {
      console.log("handleClinicChange called with doctorId:", selectedDoctorId);

      // Fetch specialities data using the selected doctorId
      const specialitiesData = await dispatch(
        fetchspecilaity(selectedDoctorId)
      );
      console.log("specialitiesData:", specialitiesData);
      setSpecialities(specialitiesData);
      setDoctorNames([]);

      if (specialitiesData.length > 0) {
        const selectedSpeciality = specialitiesData[0].speciality;
        console.log("Selected Speciality:", selectedSpeciality);
        setLoading(true);

        // Fetch doctor data using the selected doctorId, clinicId, and speciality
        const doctorData = await dispatch(
          fetchdoctor({
            doctorId: selectedDoctorId,
            clinicId: clinicId,
            speciality: selectedSpeciality,
          })
        );
        console.log("Doctor Data:", doctorData);

        // Convert doctorData to an array of { text, value } objects
        const convertedDoctorData = Object.keys(doctorData).map((doctorId) => ({
          text: doctorData[doctorId],
          value: doctorId,
        }));
        console.log("Converted Doctor Data", convertedDoctorData);
        setDoctorNames(convertedDoctorData);

        handleChangeValues({ key: "speciality", value: selectedSpeciality });
      }
    } catch (error) {
      console.error("Error fetching specialities:", error);
    }
  };

  console.log("speciality", specialities);

  // Fetch consultation data and timezone using the selected doctorId
  const fetchConsultationAndTimezoneData = async (selectedDoctorValue) => {
    try {
      const consultationData = await dispatch(
        fetchconsultation(selectedDoctorValue)
      );
      if (consultationData && consultationData.length > 0) {
        const convertedConsultationData = consultationData.map(
          (consultation) => ({
            text: consultation.typeofcons,
            value: consultation.typeofcons,
          })
        );
        setConsultationNames(convertedConsultationData);
      }

      const timezoneData = await dispatch(fetchtimezone(selectedDoctorValue));
      console.log("timezoneData:", timezoneData);
      if (timezoneData && timezoneData.info) {
        setForm((prevFormData) => ({
          ...prevFormData,
          timezone: timezoneData.info,
        }));
      }
    } catch (error) {
      console.error("Error fetching consultation and timezone data:", error);
    }
  };


  const fetchConsultationData = async (selectedDepartment) => {
    try {
      const consultationData = await dispatch(
        fetchconsultation(selectedDepartment)
      );
      if (consultationData && consultationData.length > 0) {
        const convertedConsultationData = consultationData.map(
          (consultation) => ({
            text: consultation.typeofcons,
            value: consultation.typeofcons,
          })
        );
        setConsultationNames(convertedConsultationData);
      }

      // const timezoneData = await dispatch(fetchtimezone(selectedDoctorValue));
      // console.log("timezoneData:", timezoneData);
      // if (timezoneData && timezoneData.info) {
      //   setForm((prevFormData) => ({
      //     ...prevFormData,
      //     timezone: timezoneData.info,
      //   }));
      // }
    } catch (error) {
      console.error("Error fetching consultation and timezone data:", error);
    }
  };

  useEffect(() => {
    form.setFieldsValue(interbranchData?.bookingForm);
    setInterbranchdata({
      ...interbranchData,
      bookingFormRef: form,
    });
  }, []);

  useEffect(() => {
    if (formData?.appointmentDate) {
      let _timeSlots = createTimeSlots(formData?.appointmentDate);
      setTimeSlots(_timeSlots);
    } else {
      setTimeSlots([]);
    }
  }, [formData?.appointmentDate]);

  function loaddoctors() {
    dispatch(fetch_doctors_list("Ganga Hospital")).then((res) => {
      console.log("fetch_doctors_list", res);
      if (res) {
        setDoctorNames(res);
      }
    });
  }

  const handleChangeMobileNumber = async (patientNumber) => {
    console.log("patientNumber", patientNumber);
    const data = {
      dialCode: "",
      number: patientNumber,
    };

    setForm((prev) => {
      return {
        ...prev,
        patientNumber: data,
      };
    });

    if (data.number.length >= 8) {
      setMobileNumberError(false);

      try {
        const res = await dispatch(
          fetchPatientDetail({
            patientNumber: data.number,
            countryCode: data.dialCode,
          })
        );

        if (res?.data?.info != undefined) {
          setErrormessage(res?.data?.info);
          setblockBooking(true);
          // setForm((prev) => {
          //   return {
          //     ...prev,
          //     patientNumbers:null,
          //     email: "",
          //     patientemail:"",
          //     patientName: "",
          //     dob: "",
          //     gender: "",
          //     memberName:"",
          //     appointmentFor: "",
          //     address:"",
          //   };
          // });
          let selfDetails = {
            patientName: "",
            dob: "",
            gender: "",
            address: "",
            timezone: "",
          };
          setPatientType("newPatient");
          setselfMembersDetails(selfDetails);
          loaddoctors();
        } else {
          const patientDetails = res?.data?.patientList;
          setblockBooking(false);
          setErrormessage("");
          if (patientDetails && patientDetails.length > 0) {
            setForm((prev) => {
              return {
                ...prev,
                email: patientDetails[0]?.email,
                patientemail: patientDetails[0]?.email,
                patientName: patientDetails[0]?.patientName,
                dob:
                  patientDetails[0]?.dob != undefined
                    ? moment(patientDetails[0]?.dob)
                    : "",
                gender: patientDetails[0]?.gender,
                address: patientDetails[0]?.address,
                timezone: patientDetails[0]?.timezone || "",
                memberName: "Self",
                appointmentFor: "Self",
              };
            });
            let selfDetails = {
              patientName: patientDetails[0]?.patientName,
              dob: moment(patientDetails[0]?.dob),
              gender: patientDetails[0]?.gender,
              address: patientDetails[0]?.address,
              timezome: patientDetails[0]?.timezone || "",
            };

            setselfMembersDetails(selfDetails);

            fetchFamilyMembers(patientDetails[0]?.email);
            setPatientType("existingPatient");
            loaddoctors();
          } else {
            //message.error('Patient details not found');
            // setForm((prev) => {
            //   return {
            //     ...prev,
            //     patientNumbers:null,
            //     email: "",
            //     patientemail: "",
            //     patientName: "",
            //     dob: "",
            //     gender: "",
            //     memberName:"",
            //     appointmentFor: "",
            //     address:"",
            //   };
            // });
            let selfDetails = {
              patientName: "",
              dob: "",
              gender: "",
              address: "",
              timezone: "",
            };
            setPatientType("newPatient");
            setselfMembersDetails(selfDetails);
          }
        }
      } catch (err) {
        console.error("Error in fetching patient details:", err);
        //message.error("An error occurred while fetching patient details");
      }
    } else {
      setMobileNumberError(true);
      // setForm((prev) => {
      //   return {
      //     ...prev,
      //     patientNumbers:null,
      //     email: "",
      //     patientemail:"",
      //     patientName: "",
      //     dob: "",
      //     gender: "",
      //     memberName:"",
      //     appointmentFor: "",
      //     address:"",
      //   };
      // });
      let selfDetails = {
        patientName: "",
        dob: "",
        gender: "",
        address: "",
        timezone:"",
      };
      //setPatientType("newPatient")
      setselfMembersDetails(selfDetails);
    }
  };
  const handleEmail = async (email) => {
    try {
      const res = await dispatch(
        fetchPatientDetail({ email, countryCode: "" })
      );
      if (res?.data?.info !== undefined) {
        setErrormessage(res?.data?.info);
        setblockBooking(true);
      } else {
        const patientDetails = res?.data?.patientList;
        setblockBooking(false);
        setErrormessage("");
        if (patientDetails && patientDetails.length > 0) {
          // Filter out invalid mobile numbers and take the first valid patient
          const validPatient = patientDetails.find(
            (patient) =>
              patient.mobilenumber &&
              patient.mobilenumber !== "+undefined" &&
              patient.mobilenumber !== "+91"
          );
          console.log("validPatient", validPatient);
          if (validPatient) {
            const { mobilenumber, patientName, dob, gender, address, timezone } =
              validPatient;
            let phonenumber = {
              number: mobilenumber.split(" ")[1],
              countryCode: mobilenumber.split(" ")[0],
            };

            setForm((prev) => {
              return {
                ...prev,
                patientNumbers: phonenumber,
                patientNumber: mobilenumber,
                patientName,
                dob: moment(dob),
                gender,
                memberName: "Self",
                appointmentFor: "Self",
                address,
                timezone,
              };
            });

            let selfDetails = {
              patientName,
              dob: moment(dob),
              gender,
              address,
              timezone,
            };
            setselfMembersDetails(selfDetails);
            fetchFamilyMembers(validPatient.email);
            setPatientType("existingPatient");
          } else {
            // If no valid patient found, reset the form fields
            setForm((prev) => {
              return {
                ...prev,
                patientName: "",
                dob: "",
                gender: "",
                memberName: "",
                appointmentFor: "",
                address: "",
                timezone:"",
              };
            });
            let selfDetails = {
              patientName: "",
              dob: "",
              gender: "",
              address: "",
              timezone: "",
            };
            setPatientType("newPatient");
            setselfMembersDetails(selfDetails);
          }
        } else {
          // If no patient found, reset the form fields
          setForm((prev) => {
            return {
              ...prev,
              patientName: "",
              dob: "",
              gender: "",
              memberName: "",
              appointmentFor: "",
              address: "",
              timezone: "",
            };
          });
          let selfDetails = {
            patientName: "",
            dob: "",
            gender: "",
            address: "",
            timezone: "",
          };
          setPatientType("newPatient");
          setselfMembersDetails(selfDetails);
        }
      }
    } catch (err) {
      console.error("Error in fetching patient details:", err);
    }
  };
  console.log('dep', formData?.department)

  const handleChangeValues = ({ key, value }) => {
    setForm((prevFormData) => ({
      ...prevFormData,
      [key]: value,

      timezone:
        key === "doctor"
          ? doctorTimezoneData?.info || ""
          : prevFormData.timezone,
    }));
    if (key === "doctor") {
      setIsTimeZoneEnabled(value);
    }
    if (key === "email") {
      fetchFamilyMembers(value);
    }
    if (key === "memberName") {
      console.log("memberName", value);
      // fetchFamilyMembers(value);
      if (value === "Self") {
        setForm((prevFormData) => ({
          ...prevFormData,
          appointmentFor: "Self", // Update the currency in the form data
          isnewmember: false,
        }));
      } else {
        setForm((prevFormData) => ({
          ...prevFormData,
          appointmentFor: "Loved One", // Update the currency in the form data
          isnewmember: false,
        }));
      }
    }
    if (key === "reasonForBooking") {
      setIsSumbit(false);
    }
  };

  let handlesubmitbutton = (key, e) => {
    if (key === "address") {
      if (formData?.reasonForBooking != undefined && e != "") {
        setIsSumbit(false);
      } else {
        setIsSumbit(true);
      }
    }
    if (key === "reasonForBooking") {
      if (e != "" && formData.address.replace(/^\s+/g, "") != "") {
        setIsSumbit(false);
      } else {
        setIsSumbit(true);
      }
    }
  };

  let handleOnBlurPhone = () => {
    console.log("Prefetch patient date................");
  };

  let handleFormFinish = () => {
    console.log("Form finish");
    if (FormsubmissionType == "bookrequest") {
      handleToggleBookingSuccess(true);
    } else {
      handleToggleSendSuccess(true);
    }
    form.resetFields();
  };

  let handleFormFailed = () => {
    checkIsPhoneError();
    console.log("Form finish failed");
  };

  let checkIsPhoneError = async () => {
    let isError = false;
    try {
      let _isError = await form.validateFields(["patientNumber"]);
      isError = _isError?.errorFields;
    } catch (error) {
      console.log(error);
    }

    setPhoneError(isError);
  };

  let validateLettersOnly = (event) => {
    // //console.log( event.which );

    if (event.which === 46 || event.which === 8 || event.which === 32) {
    } else if (event.which < 65 || event.which > 90) {
      event.preventDefault();
    }
  };

  let handleFileUpload = (data) => {
    setForm((prev) => {
      return {
        ...prev,
        reports: data,
      };
    });
  };

  let validateFees = (e) => {
    handleChangeValues({
      key: "consultationFees",
      value: e,
    });
  };
  const handleCurrencyChange = (e) => {
    setSelectedCurrency(e);
    setForm((prevFormData) => ({
      ...prevFormData,
      currency: e, // Update the currency in the form data
    }));
  };

  let Mandatory = () => <span className={styles.mandatory}>*</span>;

  let toggleAddPatientModal = (flag) => {
    SetAddNewForm(flag ? flag : false);
  };

  let handleToggleBookingSuccess = (flag) =>
    setBookingSuccessModal(flag ? flag : false);

  let handleToggleSendSuccess = (flag) =>
    setSendSuccessModal(flag ? flag : false);

  const addNewMember = (data) => {
    setMembers((prev) => [...prev, data]);
    setForm((prevFormData) => ({
      ...prevFormData,
      isnewmember: true, // Update the currency in the form data
    }));
    let members = {
      memberName: data.name,
      dob: moment(data.dob, "DD-MMM-YYYY").format("DD-MMM-YYYY"),
      gender: data.gender,
      relationship: data.relationship,
    };
    setFamilyMembers((prev) => [...prev, members]);
  };

  const convertMembersDataToArray = () => {
    let _temp = [];
    members.forEach((e) => {
      _temp.push(e?.name);
    });
    return _temp;
  };

  const isItemEnabled = (item_key) => {
    switch (item_key) {
      case "speciality":
        return (
          !formData?.patientNumber ||
          !formData?.email ||
          !formData?.patientName ||
          !formData?.dob ||
          !formData?.gender ||
          !formData?.address 
          // !formData?.timezone
        );
      case "department":
        return (
          
          !formData?.Speciality
          // !formData?.timezone
        );
      case "appoitmentfor":
        return !formData?.email;
      case "consultation_type":
        return !formData?.department;
      case "appointment_date":
        return !formData?.typeOfConsultation;
      case "appointment_time":
        return !formData?.appointmentDate;
      case "reports":
        return (
          !formData?.patientNumber ||
          !formData?.email ||
          !formData?.patientName ||
          !formData?.dob ||
          !formData?.gender ||
          !formData?.department
        );
      case "modeOfConsultation":
        return !formData?.appointmentTime;
      case "currency":
        return !formData?.typeOfConsultation;
      case "fees":
        return !formData?.currency;
      case "payment_id":
        return !formData?.consultationFees;
      case "payment_method":
        return !formData?.paymentId;
      case "reason_for_booking":
        return !formData?.paymentMethod;
      default:
        return true;
    }
  };

  // if (formData.consultationFees && formData.currency) {
  //   const combinedFees = formData.currency + formData.consultationFees;
  //   formData.consultationFees = combinedFees;

  //   delete formData.currency;
  // }

  const isEnableForSubmission = () => {
    console.log("formData?.reasonForBooking");
    if (isItemEnabled("reason_for_booking")) {
      return false;
    } else {
      return true;
    }
  };

  function allowOnlyNumericsOrDigits(e) {
    if (e.target.value?.length >= 8 && !["Backspace"].includes(e.key)) {
      e.preventDefault();
      //allow backspace
    } else {
      ![
        "0",
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "Backspace",
        ".",
      ].includes(e.key) && e.preventDefault();
    }
  }
  function allowOnlyNumericsOnDate(e) {
    ![
      "0",
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "Backspace",
      "-",
    ].includes(e.key) && e.preventDefault();
  }

  function handleSubmit(flag, formData, addMemberFormData) {
    const updatedFormData = { ...formData, bookingType: flag };

    setFormSubmissionType(() => flag);

    if (formData?.currency && formData?.consultationFees) {
      updatedFormData.consultationFees = `${formData.currency} ${formData.consultationFees}`;
      delete updatedFormData.currency;
    }
    //const bookedDetails = []

    const bookedDetails = [
      {
        bookedfor: formData.appointmentFor === "Self" ? "self" : "lovedone",
        id: formData.appointmentFor === "Loved One" ? formData.memberName : "",
        lovedname: addMemberFormData?.name || "",
        dob: moment(addMemberFormData?.dob).format("DD/MMM/YYYY") || "",
        gender: addMemberFormData?.gender || "",
        relation:
          formData.appointmentFor === "Loved One"
            ? "member"
            : "rel-" + addMemberFormData?.relationship || "",
      },
    ];

    dispatch(bookingformRequest(updatedFormData, flag, bookedDetails))
      .then((res) => {
        console.log("submitted successfully", res);
        setLoader(false);

        if (res?.bookingId) {
          setSuccessMessage(res.bookingId);
          setBookingSuccessModal(true);
          form.resetFields();
          setForm({});
          setFamilyMembers([]);
          setShowself(false);
          setPatientType("newPatient");
          setIsAppointmentAlreadyBooked(false);
        } else if (
          res?.info &&
          res.info.includes("This appointment is already booked")
        ) {
          setSuccessMessage(res.info);
          setBookingSuccessModal(true);
          setIsAppointmentAlreadyBooked(true);
        } else {
          form.resetFields();
          setForm({
            email: "",
            isbookingcompleted: true,
          });

          if (flag === "bookrequest") {
            handleToggleBookingSuccess(true);
            setSuccessMessage(res.bookingId);
          } else {
            handleToggleSendSuccess(true);
          }
        }
        // form.resetFields();
      })
      .catch((err) => {
        console.log("Error submitting form", err);
      });
    // form.submit();
  }

  function handleAddMemberFormFinish(flag, data) {
    if (mobileNumberError) {
      message.error("Please enter a valid mobile number");
      return;
    }
    
    console.log(data);
    setLoader(true);
    let form_vals = form.getFieldsValue();
    console.log("form_vals", form_vals);
    // form.resetFields();
    setIsSumbit(true);
    handleSubmit(flag, formData, data);
  }

  function disabledDateLessThan18(current) {
    // Get the date 18 years ago from the current date
    //console.log("current",current)
    const eighteenYearsAgo = moment().subtract(1, "days");
    // Disable dates that are before 18 years ago from the current date
    //return current && current > eighteenYearsAgo;
    return current && current.valueOf() > Date.now();
  }

  const handleChange = (e) => {
    setPatientType(e.target.value);
    setForm((prev) => {
      return {
        ...prev,
        patientNumbers: null,
        patientemail: "",
        email: "",
        patientName: "",
        dob: "",
        gender: "",
        memberName: "",
        appointmentFor: "",
        address: "",
        timezone: "",
      };
    });
  };

  const handleInput = (e) => {
    const englishRegex = /^[a-zA-Z0-9\s,.-]*$/;
    const value = e.target.value;

    if (englishRegex.test(value)) {
      e.target.value = value.replace(/\s+/g, " ");
    } else {
      e.target.value = ""; // Clear the input value
    }
  };

  console.log("formData", formData);

  consultationNames.map((option) => {
    console.log("99999", option.text);
  });
console.log('number',formData)
  return (
    <div className={styles.container}>
      <div className={styles.body}>
        <div className={styles.contentWrap}>
          <div className={styles.formBody} style={{ margin: 0 }}>
            <div className={styles.formItem}>
              <div className={styles.inputItem}>
                <Radio.Group
                  value={patienType}
                  onChange={(e) => {
                    form.resetFields();
                    handleChange(e);
                    handleChangeValues({
                      key: "isNewPatient",
                      value: e.target.value,
                    });
                    setFamilyMembers([]);
                    setShowself(false);
                  }}
                >
                  <Radio value={"newPatient"}>New patient</Radio>
                  <Radio value={"existingPatient"}>Existing patient</Radio>
                </Radio.Group>
              </div>
            </div>
          </div>

          <Form
            onValuesChange={(values, allValues) => {
              setInterbranchdata({
                ...interbranchData,
                bookingForm: allValues,
              });
            }}
            form={form}
            onFinish={handleFormFinish}
            onFinishFailed={handleFormFailed}
          >
            <div className={styles.sctionTitle}>
              Patient Details
              {/* <button
                type="button"
                className={styles.addNewMemberBtn}
                onClick={() => {
                  toggleAddPatientModal(true);
                }}
              >
                Add new member +
              </button> */}
            </div>
            <div className={styles.formBody}>
              <div className={styles.formItem}>
                <div className={styles.caption}>Mobile Number <Mandatory />
                </div>
                <div className={styles.inputItem}>
                  <Form.Item
                    name="patientNumber"
                    rules={[
                      {
                        required: true,
                        message: "*Please enter mobile number",
                      },
                    ]}
                  >
                    <div
                      className={` ${styles.phoneWrap} ${
                        isPhoneError ? styles.phoneError : null
                      }`}
                    >
                      <CustomPhoneInputV2
                        hasFeedback
                        onBlur={handleOnBlurPhone}
                        defaultCountryCode={
                          formData?.patientNumbers?.countryCode || "91"
                        }
                        defaultvalue={formData?.patientNumbers?.number || ""}
                        //onChange={handleChangeMobileNumber}
                        onChange={(number, value, data, event) => {
                          console.log({ number, value, data });
                          handleChangeMobileNumber(value);
                          // handleOnChange(value, data, event);
                        }}
                        value={formData?.patientNumbers?.number || ""}
                        name="patientNumber"
                        placeholder={"Enter mobile number"}
                      />
                    </div>

                    {/* <Input style={{ width: "100%" }} className='input' placeholder="" /> */}
                  </Form.Item>
                </div>
                {errormessage != "" && (
                  <span style={{ color: "#ff4d4f", fontSize: "12.5px" }}>
                    {errormessage}
                  </span>
                )}
              </div>

              <div className={styles.formItem}>
                <div className={styles.caption}>Email ID <Mandatory /> 
                </div>
                <div className={styles.inputItem}>
                  <Form.Item
                    name="email"
                    //</div>initialValue: formData.testemaiid,
                    rules={[
                      {
                        required: true,
                        message: "*Please enter email id",
                      },
                      {
                        type: "email",
                        message: "*Please enter a valid email id",
                      },
                    ]}
                  >
                    <Input
                      // readOnly={patienType==="existingPatient"?true:false}
                      value={formData?.email || ""}
                      onChange={(e) => {
                        handleChangeValues({
                          key: "email",
                          value: e.target.value,
                        });

                        handleEmail(e.target.value);
                      }}
                      className={styles.input}
                      data={formData?.email}
                      placeholder="Enter email id"
                      onKeyPress={(e) => {
                        const englishRegex = /^[a-zA-Z0-9@\.\s]*$/;
                        if (
                          !englishRegex.test(e.key) &&
                          e.key !== "Backspace" &&
                          e.key !== "Delete"
                        ) {
                          e.preventDefault();
                        }
                      }}
                      onPaste={(e) => {
                        const pastedData =
                          e.clipboardData.getData("text/plain");
                        const englishRegex = /^[a-zA-Z0-9@\.\s]*$/;
                        if (!englishRegex.test(pastedData)) {
                          e.preventDefault();
                        }
                      }}
                    />
                  </Form.Item>
                  {/* <Form.Item
                    name="email"
                    initialValue: formData.testemaiid,
                    rules={[
                      {
                        required: true,
                        message: "*Please enter email id",
                      },
                      {
                        type: "email",
                        message: "*Please enter a valid email id",
                      },
                    ]}
                  >
                    <Input
                    
                      value={formData?.patientemail||""} 
                      onChange={(e) => {
                        handleChangeValues({
                          key: "patientemail",
                          value: e.target.value,
                        });
                      }}
                    
                      className={styles.input}
                      data={formData?.email}
                      placeholder="Enter email id"
                    />  
                  </Form.Item>  */}
                </div>
                {emailerrormsg != "" && (
                  <span style={{ color: "#ff4d4f", fontSize: "12.5px" }}>
                    {emailerrormsg}
                  </span>
                )}
              </div>

              <div className={styles.formItem}>
                <div className={styles.caption}>
                  Appointment For <Mandatory />
                </div>
                <div className={`${styles.inputItem} ${styles.appointmentfor}`}>
                  <Select
                    getPopupContainer={(trigger) => trigger.parentNode}
                    disabled={isItemEnabled("appoitmentfor")}
                    value={formData?.memberName || undefined}
                    onChange={(value) => {
                      handleChangeValues({ key: "memberName", value });

                      const foundObject = familyMembers.find(
                        (item) => item.id === value
                      );
                      console.log("foundObject", foundObject);
                      if (value === "Self") {
                        setForm((prev) => {
                          return {
                            ...prev,

                            patientName: selfMembersDetails.patientName,
                            dob: moment(selfMembersDetails?.dob),
                            gender: selfMembersDetails?.gender,
                            address: selfMembersDetails?.address,
                          };
                        });
                        if (
                          selfMembersDetails.address != null &&
                          selfMembersDetails.address != undefined
                        ) {
                          handlesubmitbutton(
                            "address",
                            selfMembersDetails.address
                          );
                        }
                      } else {
                        setForm((prev) => {
                          return {
                            ...prev,

                            patientName: foundObject.memberName,
                            dob: moment(foundObject.dob),
                            gender: foundObject.gender,
                            address: foundObject.address,
                            // timezone: foundObject.timezone,
                          };
                        });
                        let details = {
                          dob: foundObject.dob,
                          gender: foundObject.gender,
                          name: foundObject.memberName,
                        };
                        setfamilyMembersDetails(details);
                        if (
                          foundObject.address != null &&
                          foundObject.address != undefined
                        ) {
                          handlesubmitbutton("address", foundObject.address);
                        }
                      }
                    }}
                    placeholder="Select"

                    // className={styles.appointmentfor}
                  >
                    {showself && (
                      <Select.Option key={1} value="Self">
                        Self
                      </Select.Option>
                    )}
                    {familyMembers.map((member) => (
                      <Select.Option key={member.id} value={member.id}>
                        {member.memberName}({member.relationship})
                      </Select.Option>
                    ))}
                    {/* <Select.Option key={3} value="addnew">
                Add new member +
                  </Select.Option> */}
                  </Select>
                </div>
              </div>

              <div className={styles.formItem}>
                <div className={styles.caption}>
                  Patient Name <Mandatory />
                </div>
                <div className={styles.inputItem}>
                  <div
                    name="patientName"
                    rules={[
                      {
                        required: true,
                        message: "*Please enter patient name",
                      },
                      {
                        pattern: new RegExp("^[a-zA-Z_ ]+$"),
                        message: "Enter only Alphabets",
                      },
                    ]}
                  >
                    <Tooltip
                      placement="top"
                      title={formData?.patientName || ""}
                    >
                      <input
                        readOnly={
                          patienType === "existingPatient" ? true : false
                        }
                        value={formData?.patientName || ""}
                        onChange={(e) => {
                          handleChangeValues({
                            key: "patientName",
                            value: e.target.value,
                          });
                        }}
                        onKeyDown={validateLettersOnly}
                        style={{ width: "100%" }}
                        className={styles.input}
                        placeholder="Enter full name"
                        maxLength={30}
                        onKeyPress={(e) => {
                          const englishRegex = /^[a-zA-Z0-9\.\s]*$/;
                          if (
                            !englishRegex.test(e.key) &&
                            e.key !== "Backspace" &&
                            e.key !== "Delete"
                          ) {
                            e.preventDefault();
                          }
                        }}
                        onPaste={(e) => {
                          const pastedData =
                            e.clipboardData.getData("text/plain");
                          const englishRegex = /^[a-zA-Z0-9\.\s]*$/;
                          if (!englishRegex.test(pastedData)) {
                            e.preventDefault();
                          }
                        }}
                      />
                    </Tooltip>
                    {/* <AutoComplete
                      getPopupContainer={(trigger) => trigger.parentNode}
                      onKeyDown={validateLettersOnly}
                      value={formData?.patientName || ""}
                      onChange={(e) => {
                        handleChangeValues({
                          key: "patientName",
                          value: e,
                        });
                      }}
                      className={`${styles.input} ${styles.patientNameBox}`}
                      options={createDropdownValues(
                        convertMembersDataToArray()
                      )}
                      style={{
                        width: 200,
                      }}
                      placeholder="Enter name"
                    /> */}
                  </div>
                </div>
              </div>

              <div className={styles.formItem}>
                <div className={styles.caption}>
                  Date of Birth <Mandatory />
                </div>
                <div className={`${styles.inputItem} ${styles.dateInputItem}`}>
                  <div
                    name="dob"
                    rules={[
                      {
                        required: true,
                        message: "*Please select DOB",
                      },
                    ]}
                  >
                    <DatePicker
                      det
                      onKeyDown={allowOnlyNumericsOnDate}
                      getPopupContainer={(trigger) => trigger.parentNode}
                      disabledDate={disabledDateLessThan18}
                      //  disabledDate={(current) =>
                      //   current.isBefore(moment().subtract(1, "day"))
                      // }
                      defaultPickerValue={moment().subtract(1, "day")}
                      showToday={false}
                      showNow={false}
                      //value={formData?.dob || null}
                      value={
                        formData?.dob != undefined
                          ? moment(formData.dob, "DD-MMM-YYYY", "en").isValid()
                            ? moment(formData.dob, "DD-MMM-YYYY", "en")
                            : null
                          : null
                      }
                      onChange={(e) => {
                        handleChangeValues({ key: "dob", value: e });
                      }}
                      className={`${styles.input}`}
                      style={{
                        width: "100% !important",
                        maxWidth: "302px !important",
                      }}
                      format="DD-MMM-YYYY"
                      placeholder="DD-MM-YYYY"
                    />
                    {/* <DatePicker
                      det
                      onKeyDown={allowOnlyNumericsOnDate}
                      getPopupContainer={(trigger) => trigger.parentNode}
                      disabledDate={disabledDateLessThan18}
                      defaultPickerValue={moment().subtract(18, "years")}
                      showToday={false}
                      showNow={false}
                      value={formData?.dob!=undefined ? moment(formData.dob, 'DD-MMM-YYYY', 'en').isValid()
                      ? moment(formData.dob, 'DD-MMM-YYYY', 'en'):null : null}
                      onChange={(date) => {
                        handleChangeValues({ key: 'dob', value: date ? moment(date, 'DD-MMM-YYYY', 'en').format('DD-MM-YYYY') : null });
                      }}
                      className={`${styles.input}`}
                      style={{
                        width: "100% !important",
                        maxWidth: "302px !important",
                      }}
                      format="DD-MMM-YYYY"
                      placeholder="DD-MM-YYYY"
                    /> */}
                  </div>
                </div>
              </div>

              <div className={styles.formItem}>
                <div className={styles.caption}>
                  Gender <Mandatory />
                </div>
                <div className={`${styles.inputItem}`}>
                  <div
                    name="gender"
                    rules={[
                      {
                        required: true,
                        message: "*Please select gender",
                      },
                    ]}
                  >
                    <GenderPicker
                      value={formData?.gender || null}
                      onChange={(e) => {
                        handleChangeValues({
                          key: "gender",
                          value: e,
                        });
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className={styles.formItem} style={{ width: "340px" }}>
                <div className={styles.caption}>
                  Address <Mandatory />
                </div>
                <div
                  className={`${styles.inputItem}`}
                  style={{ width: "100%" }}
                >
                  <div
                    name="address"
                    style={{ width: "100%" }}
                    rules={[
                      {
                        required: true,
                        message: "*Please enter patient full address",
                      },
                    ]}
                  >
                    <TextArea
                      rows={4}
                      placeholder="Enter Full Address including City and State"
                      value={formData?.address || null}
                      onChange={(e) => {
                        handleChangeValues({
                          key: "address",
                          value: e.target.value.replace(/^\s+/g, ""),
                        });
                        handlesubmitbutton(
                          "address",
                          e.target.value.replace(/^\s+/g, "")
                        );
                      }}
                      style={{ borderRadius: "5px", fontWeight: "500" }}
                      onKeyPress={(e) => {
                        const englishRegex = /^[a-zA-Z0-9\s,.-]*$/;
                        if (
                          !englishRegex.test(e.key) &&
                          e.key !== "Backspace" &&
                          e.key !== "Delete"
                        ) {
                          e.preventDefault();
                        }
                      }}
                      onPaste={(e) => {
                        const pastedData =
                          e.clipboardData.getData("text/plain");
                        const englishRegex = /^[a-zA-Z0-9\s,.-]*$/;
                        if (!englishRegex.test(pastedData)) {
                          e.preventDefault();
                        }
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>

          
            <div className={styles.sctionTitle}>Appointment Details</div>
            <div className={styles.formBody} style={{ marginBottom: "0px" }}>
            <div className={styles.formItem}>
                <div className={styles.caption}>
                  Speciality <Mandatory />
                </div>
                <div className={styles.inputItem}>
                  <Form.Item
                    name="Speciality"
                    rules={[
                      {
                        required: true,
                        message: "*Please select Speciality",
                      },
                    ]}
                  >
                    <Select
                      disabled={isItemEnabled("speciality")}
                      value={formData?.Speciality || undefined}
                      onChange={(value, option) => {
                        handleChangeValues({
                          key: "Speciality",
                          value: option.children, // department name
                        });
                       fetchDepartments(option.children)
                        
                      }}
                      
                      style={{ width: 300 }}
                      placeholder="Please select Speciality"
                      className="department-dropdown"
                    >
                      {specialityOptions.map((department) => (
                        <Option key={department.id} value={department.id}>
                          {department.name}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </div>
              </div>
            <div className={styles.formItem}>
                <div className={styles.caption}>
                  Department <Mandatory />
                </div>
                <div className={styles.inputItem}>
                  <Form.Item
                    name="department"
                    rules={[
                      {
                        required: true,
                        message: "*Please select department",
                      },
                    ]}
                  >
                    <Select
                      disabled={isItemEnabled("department")}
                      value={formData?.department || undefined}
                      onChange={(value, option) => {
                        handleChangeValues({
                          key: "department",
                          value: option.children, // department name
                        });
                        handleChangeValues({
                          key: "specialityId",
                          value: option.value, //specialityId
                        });
                        setSelectedDepartment(value);
                        fetchConsultationData(value);
                      }}
                      
                      style={{ width: 300 }}
                      placeholder="Please select department"
                      className="department-dropdown"
                    >
                      {departmentOptions.map((department) => (
                        <Option key={department.id} value={department.id}>
                          {department.name}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </div>
              </div>
              <div className={styles.formItem}>
                <div className={styles.caption}>
                  Type of Consultation <Mandatory />
                </div>
                <div className={styles.inputItem}>
                  <Form.Item
                    name="typeOfConsultation"
                    rules={[
                      {
                        required: true,
                        message: "*Please select type of consultation",
                      },
                    ]}
                  >
                    <Dropdown
                      disabled={isItemEnabled("consultation_type")}
                      value={formData?.typeOfConsultation || undefined}
                      onChange={(e) => {
                        handleChangeValues({
                          key: "typeOfConsultation",
                          value: e,
                        });
                      }}
                      data={createDropdownValues(
                        formData?.department
                          ? consultationNames.map((option) => (
                              <option key={option.value} value={option.value}>
                                {option.text}
                              </option>
                            ))
                          : []
                      )}
                      width={300}
                      placeholder="Select type of consultation"
                    />
                  </Form.Item>
                </div>
              </div>
              {/* <div className={styles.formItem}>
                <div className={styles.caption}>
                  Appointment Date <Mandatory />
                </div>
                <div className={styles.inputItem}>
                  <Form.Item
                    name="appointmentDate"
                    rules={[
                      {
                        required: true,
                        message: "*Please select appointment date",
                      },
                    ]}
                  >
                    <DatePicker
                      disabled={isItemEnabled("appointment_date")}
                      onKeyDown={allowOnlyNumericsOnDate}
                      getPopupContainer={(trigger) => trigger.parentNode}
                      disabledDate={(current) =>
                        current.isBefore(moment().subtract(1, "day"))
                      }
                      value={formData?.appointmentDate || undefined}
                      onChange={(e) => {
                        handleChangeValues({
                          key: "appointmentDate",
                          value: moment(e, "DD-MMM-YYYY"),
                        });
                      }}
                      className={styles.input}
                      style={{ width: "100% !important" }}
                      format="DD-MMM-YYYY"
                      placeholder="Select appointment date"
                    />
                  </Form.Item>
                </div>
              </div>
              <div className={styles.formItem}>
                <div className={styles.caption}>
                  Appointment Time <Mandatory />
                </div>
                <div className={styles.inputItem}>
                  <Form.Item
                    name="appointmentTime"
                    rules={[
                      {
                        required: true,
                        message: "*Please select appointment time",
                      },
                    ]}
                  >
                    <Dropdown
                      disabled={isItemEnabled("appointment_time")}
                      value={formData?.appointmentTime || undefined}
                      onChange={(e) => {
                        handleChangeValues({
                          key: "appointmentTime",
                          value: e,
                        });
                      }}
                      data={createDropdownValues(timeSlots)}
                      width={300}
                      placeholder="Select appointment time"
                    />
                  </Form.Item>
                </div>
              </div> */}
              {/* <div className={styles.formItem}>
                <div className={styles.caption}>
                  Mode of Consultation <Mandatory />
                </div>
                <div className={styles.inputItem}>
                  <Form.Item
                    name="modeOfConsultation"
              
                  >
                   
                    <Dropdown
                      //defaultValue="Please select mode"
                      disabled={isItemEnabled("modeOfConsultation")}
                      value={formData?.modeOfConsultation || undefined}
                      onChange={(e) => {
                        handleChangeValues({
                          key: "modeOfConsultation",
                          value: e,
                        });
                      }}
                      width={300}
                      data={createDropdownValues(tempData.modeOfConsultation)}
                      placeholder="Select one"
                    />
                  </Form.Item>
                </div>
              </div> */}
            </div>

            {/* <div className={styles.caption}>Reports</div>
            <UploadReportComponent
              disabled={isItemEnabled("reports")}
              files={formData?.reports || []}
              onFileUpload={handleFileUpload}
              onFileRemove={() => { }}
            /> */}

            <div className={styles.sctionTitle}>Payment Details</div>
            <div className={styles.formBody}>
              <div className={styles.formItem}>
                <div className={styles.caption}>
                  Consultation fee <Mandatory />
                </div>
                <div className={`${styles.inputItem} ${styles.inputItemFees}`}>
                  <Form.Item
                    name="currency"
                    rules={[
                      {
                        required: true,
                        message: "*Please enter fee",
                      },
                    ]}
                    className={styles.currencyFormItem}
                  >
                    <Dropdown
                      showSearch
                      onChange={(e) => {
                        handleChangeValues({
                          key: "currency",
                          value: e,
                        });
                      }}
                      disabled={isItemEnabled("currency")}
                      width={130}
                      data={createDropdownValues(dummyCurrency)}
                      placeholder="Currency"
                    />
                  </Form.Item>
                  <Form.Item
                    name="consultationFees"
                    rules={[
                      {
                        required: true,
                        message: "*Please select currency",
                      },
                    ]}
                    className={styles.feesFormItem}
                  >
                    <Input
                      disabled={isItemEnabled("fees")}
                      value={formData?.consultationFees || ""}
                      onChange={(e) => {
                        validateFees(e.target.value);
                      }}
                      onKeyDown={allowOnlyNumericsOrDigits}
                      style={{ width: "100%" }}
                      className={styles.input}
                      placeholder="Enter fees"
                      maxLength={5}
                    />
                  </Form.Item>
                </div>
              </div>

              <div className={styles.formItem}>
                <div className={styles.caption}>
                  Payment Id <Mandatory />
                </div>
                <div className={styles.inputItem}>
                  <Form.Item
                    name="paymentId"
                    rules={[
                      {
                        required: true,
                        message: "*Please enter payment id",
                      },
                    ]}
                  >
                    <Input
                      disabled={isItemEnabled("payment_id")}
                      value={formData?.paymentId || ""}
                      onChange={(e) => {
                        handleChangeValues({
                          key: "paymentId",
                          value: e.target.value,
                        });
                      }}
                      style={{ width: "100%" }}
                      className={styles.input}
                      placeholder="Enter payment id"
                      maxLength={30}
                      onKeyPress={(e) => {
                        const englishRegex = /^[a-zA-Z0-9_\.\s]*$/;
                        if (
                          !englishRegex.test(e.key) &&
                          e.key !== "Backspace" &&
                          e.key !== "Delete"
                        ) {
                          e.preventDefault();
                        }
                      }}
                      onPaste={(e) => {
                        const pastedData =
                          e.clipboardData.getData("text/plain");
                        const englishRegex = /^[a-zA-Z0-9_\.\s]*$/;
                        if (!englishRegex.test(pastedData)) {
                          e.preventDefault();
                        }
                      }}
                    />
                  </Form.Item>
                </div>
              </div>
              <div className={styles.formItem}>
                <div className={styles.caption}>
                  Payment Method <Mandatory />
                </div>
                <div className={styles.inputItem}>
                  <Form.Item
                    name="paymentMethod"
                    rules={[
                      {
                        required: true,
                        message: "*Please select payment method",
                      },
                    ]}
                  >
                    <Dropdown
                      disabled={isItemEnabled("payment_method")}
                      value={formData?.paymentMethod || undefined}
                      onChange={(e) => {
                        handleChangeValues({
                          key: "paymentMethod",
                          value: e,
                        });
                      }}
                      width={300}
                      data={createDropdownValues(tempValues.paymentMethod)}
                      placeholder="Select payment method"
                    />
                  </Form.Item>
                </div>
              </div>
              <div className={styles.formItem}>
                <div className={styles.caption}>
                  Reason for Booking <Mandatory />
                </div>
                <div className={styles.inputItem}>
                  <Form.Item
                    name="reasonForBooking"
                    rules={[
                      {
                        required: true,
                        message: "*Please select reason for booking",
                      },
                    ]}
                  >
                    <Dropdown
                      disabled={isItemEnabled("reason_for_booking")}
                      value={formData?.reasonForBooking || undefined}
                      onChange={(e) => {
                        handleChangeValues({
                          key: "reasonForBooking",
                          value: e,
                        });
                        handlesubmitbutton("reasonForBooking", e);
                      }}
                      width={370}
                      data={createDropdownValues(tempReasons)}
                      placeholder="Please select reason for booking"
                    />
                  </Form.Item>
                </div>
              </div>
            </div>
            <div className={styles.buttonContainer}>
              {!blockBooking && (
                <button
                  disabled={isSumbit || mobileNumberError && !isAppointmentAlreadyBooked}
                  onClick={() => {
                    handleAddMemberFormFinish("bookrequest");
                  }}
                  //disabled={isItemEnabled("reason_for_booking") && formData?.reasonForBooking!=undefined?false:true}
                  className={styles.submitButton}
                  type="button"
                  //  style={{background:"#003d75"}}
                >
                  REQUEST NOW
                </button>
              )}

              {/* <button
                onClick={() => {
                  handleAddMemberFormFinish("send");
                }}
                className={`${styles.submitButton} ${styles.secondarySubmitButton}`}
                type="button"
                disabled={isSumbit}
              >
                SEND TO PATIENT
              </button> */}
            </div>
          </Form>
        </div>

        {/* <PatientDetails />
      <DoctorDetails />
      <AppointmentDetails />
      <PaymentDetails /> */}

        {loader === true && (
          <div
            style={{
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              color: "#208ce1",
              position: "fixed",
            }}
          >
            <Spinner animation="border" role="status">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </div>
        )}

        <AddMemberModal
          showModal={addNewForm}
          hidemodal={() => {
            toggleAddPatientModal(false);
          }}
          onSuccess={addNewMember}
          familyMembers={familyMembers}
          handleFormFinish={handleAddMemberFormFinish}
        />

        <SuccesModal
          message={successmessage}
          isOpen={bookingSuccessModal}
          bookingId={
            successmessage?.includes("This appointment is already booked")
              ? null
              : successmessage
          }
          handleClose={handleToggleBookingSuccess}
          bookingType="bookrequest"
        />

        <SuccesModal
          message="Send to patient succesfully !!!"
          isOpen={sendSuccessModal}
          handleClose={handleToggleSendSuccess}
        />
      </div>
    </div>
  );
}

export default BoookRequest;

const SuccesModal = ({
  handleClose,
  isOpen,
  message,
  bookingId,
  bookingType,
}) => {
  
  return (
    <Modal
      className={styles.interBranchModal}
      footer={false}
      closeIcon={false}
      title={false}
      open={isOpen}
    >
      <div className={styles.reem_modal_body}>
        {message && message.includes("This appointment is already booked") ? (
          <h4>{message}</h4>
        ) : bookingId ? (
          <>
            <p style={{ fontSize: "19px" }}>
              Appointment requested successfully
            </p>
            <h5 style={{ textAlign: "center" }}>
              Request Id - <b>{bookingId}</b>
            </h5>
          </>
        ) : (
          <h4>{message}</h4>
        )}
      </div>

      <div className={styles.interBranchModalFooter}>
        <button
          onClick={() => {
            handleClose(false);
          }}
          className={styles.ok_btn}
          style={{ background: "#003d75" }}
        >
          CLOSE
        </button>
      </div>
    </Modal>
  );
};
